export enum MultiToggleSizeEnum {
  XSMALL = 'multi-toggle-xsmall',
  SMALL = 'multi-toggle-small',
  MEDIUM = 'multi-toggle-medium',
  LARGE = 'multi-toggle-large',
}
